"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var productContract = /** @class */ (function () {
    function productContract(props) {
        this.productContractId = props.productContractId;
        this.reference = props.reference;
        this.contractName = props.contractName;
        this.beneficiary = props.beneficiary;
        this.contractor = props.contractor;
        this.billingAgreementId = props.billingAgreementId;
        this.serviceConditionId = props.serviceConditionId;
        this.startDate = props.startDate;
        this.commissioningDate = props.commissioningDate;
        this.endDate = props.endDate;
        this.productContractStatusCode = props.productContractStatusCode;
        this.sanitationTypeCode = props.sanitationTypeCode;
        this.residenceTypeCode = props.residenceTypeCode;
        this.productContractTypeCode = props.productContractTypeCode;
        this.tenantId = props.tenantId;
    }
    return productContract;
}());
exports.default = productContract;
